import React from 'react';
import {View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import MultiBoxAlert from '../scanpack/multiBoxAlert';
import {clearPrintSlipNotice} from '../../actions/scanpackScanningSetters';

export const PRINT_SLIP_NOTICE_Z_INDEX = 10001;

const PrintSlipNoticeHost = () => {
  const dispatch = useDispatch();
  const noticeId = useSelector(state => state.scanPackScanning.printSlipNotice);

  if (noticeId === null || noticeId === undefined) return null;

  return (
    <View
      testID="printSlipNoticeHost"
      pointerEvents="box-none"
      style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: PRINT_SLIP_NOTICE_Z_INDEX}}>
      <MultiBoxAlert printSlipFailed onCloseAlertMultiBox={() => dispatch(clearPrintSlipNotice(noticeId))} />
    </View>
  );
};

export default PrintSlipNoticeHost;
